require.context('../images', true);

import './application';
import 'bootstrap-icons/font/bootstrap-icons';
import '../styles/twitter_bootstrap';
import '../styles/layout';
import '../scripts/homepage';
import '../scripts/consultation';
import '../scripts/analysis';
import '../scripts/viva';
import '../scripts/watch';
import '../scripts/powerful_words';
import '../scripts/landing';